import { axiosInstance } from ".."

const walletLedger = async (querry) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/wallet/ledger?${querry}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default walletLedger;